export const LIGHT_THEME = 'light';
export const DARK_THEME = 'dark';

export type AppTheme = typeof LIGHT_THEME | typeof DARK_THEME;
export const PREFERRED_THEME_LOCAL_STORAGE_KEY = 'preferredTheme';
